import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
    Mail,
    Phone,
    MapPin,
    MessageCircle,
    Twitter,
    Linkedin,
    Instagram,
    Send,
    CheckCircle,
    Clock,
} from "lucide-react";
import BackToTop from "../../components/backToTop/BackToTop";
import Footer from "../../layouts/Footer";
import Header from "../../layouts/Header";
import HeroBg from "../../../src/images/hero-bg.png";
import AuthPopup from "../../components/popup/AuthPopup";


const Contact = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: "",
        priority: "normal"
    });

    const [formStatus, setFormStatus] = useState({
        submitted: false,
        success: false,
        message: ""
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showAuth, setShowAuth] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        // Simulate API call
        setTimeout(() => {
            setFormStatus({
                submitted: true,
                success: true,
                message: "Thank you for reaching out! Our team will get back to you within 24 hours."
            });
            setIsSubmitting(false);

            // Reset form
            setFormData({
                name: "",
                email: "",
                subject: "",
                message: "",
                priority: "normal"
            });
        }, 1500);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <div className="bg-gradient-to-b from-gray-50 to-white">
            <BackToTop />

            {/* ================= HEADER ================= */}
            <Header loginClick={() => { setShowAuth(true) }} />


            <div className="relative">

                <div className="absolute inset-0 w-full h-full">
                    <img
                        src={HeroBg}
                        loading="lazy"
                        sizes="(max-width: 1440px) 100vw, 1440px"
                        alt="hero"
                        className="w-full h-full object-cover"
                    />
                </div>

                {/* <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute top-0 -left-40 w-[400px] h-[400px] bg-gradient-to-r from-indigo-200/20 via-purple-200/20 to-pink-200/20 rounded-full blur-3xl animate-float-slow"></div>
                    <div className="absolute bottom-0 -right-40 w-[400px] h-[400px] bg-gradient-to-l from-pink-200/20 via-purple-200/20 to-indigo-200/20 rounded-full blur-3xl animate-float-slower"></div>

                    {[...Array(50)].map((_, i) => (
                        <div
                            key={i}
                            className="absolute w-1 h-1 bg-gradient-to-r from-indigo-400 to-purple-400 rounded-full animate-float-particle"
                            style={{
                                left: `${Math.random() * 100}%`,
                                top: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 8}s`,
                                animationDuration: `${15 + Math.random() * 15}s`,
                                opacity: 0.2,
                            }}
                        />
                    ))}
                </div> */}

                {/* Main Content */}
                <div className="max-w-7xl mx-auto px-6 py-20 relative">
                    {/* Hero Section */}
                    <div className="text-center my-12">
                        <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full mb-6">
                            <MessageCircle className="h-4 w-4 text-indigo-600" />
                            <span className="text-sm font-medium text-indigo-600">Get in Touch</span>
                        </div>
                        <h1 className="text-4xl md:text-5xl font-bold mb-4">
                            Contact{" "}
                            <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                                Us
                            </span>
                        </h1>
                        <p className="text-xl text-gray-500 max-w-2xl mx-auto">
                            Have questions? We're here to help. Reach out to our team and we'll get back to you within 24 hours.
                        </p>
                    </div>

                    {/* Contact Grid */}
                    <div className="grid lg:grid-cols-3 gap-8">
                        {/* Left Column - Contact Info */}
                        <div className="lg:col-span-1 space-y-6">
                            {/* Quick Contact Cards */}
                            <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
                                <h2 className="text-lg font-semibold mb-4">Quick Contact</h2>
                                <div className="space-y-6">
                                    <a href="mailto:support@socialtv.com" className="flex items-center gap-3 text-gray-600 hover:text-indigo-600 transition-colors group">
                                        <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center group-hover:bg-indigo-100 transition-colors">
                                            <Mail className="h-5 w-5 text-indigo-600" />
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-400">Email</p>
                                            <p className="font-medium">publisher@jambojar.com</p>
                                        </div>
                                    </a>

                                    <a href="tel:+18001234567" className="flex items-center gap-3 text-gray-600 hover:text-indigo-600 transition-colors group">
                                        <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center group-hover:bg-indigo-100 transition-colors">
                                            <Phone className="h-5 w-5 text-indigo-600" />
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-400">Phone</p>
                                            <p className="font-medium">+91 8770887988</p>
                                        </div>
                                    </a>

                                    <div className="flex items-center gap-3 text-gray-600">
                                        <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center">
                                            <Clock className="h-5 w-5 text-indigo-600" />
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-400">Business Hours</p>
                                            <p className="font-medium">24/7 Support</p>
                                            <p className="text-sm text-gray-500">Available from 10:00 – 19:00</p>
                                        </div>
                                    </div>

                                    <div className="flex items-center gap-3 text-gray-600">
                                        <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center">
                                            <MapPin className="h-5 w-5 text-indigo-600" />
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-400">Office</p>
                                            <p className="font-medium">India</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Social Links */}
                            <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100 hidden">
                                <h2 className="text-lg font-semibold mb-4">Follow Us</h2>
                                <div className="flex gap-3">
                                    <Link to="#" className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-all">
                                        <Twitter className="h-5 w-5" />
                                    </Link>
                                    <Link to="#" className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-all">
                                        <Instagram className="h-5 w-5" />
                                    </Link>
                                    <Link to="#" className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-all">
                                        <Linkedin className="h-5 w-5" />
                                    </Link>
                                    <Link to="#" className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-all">
                                        <MessageCircle className="h-5 w-5" />
                                    </Link>
                                </div>
                            </div>

                            {/* Office Hours */}
                            {/* <div className="bg-gradient-to-br from-indigo-600 to-purple-600 rounded-2xl shadow-lg p-6 text-white">
                            <h3 className="text-lg font-semibold mb-2">Emergency Support?</h3>
                            <p className="text-indigo-100 text-sm mb-4">
                                For urgent issues outside business hours, our emergency support team is available 24/7.
                            </p>
                            <a
                                href="tel:+18001234567"
                                className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg hover:bg-white/30 transition-colors"
                            >
                                <Phone className="h-4 w-4" />
                                <span>Emergency Hotline</span>
                            </a>
                        </div> */}
                        </div>

                        {/* Right Column - Contact Form */}
                        <div className="lg:col-span-2">
                            <div className="bg-white rounded-3xl shadow-xl p-8 border border-gray-100">
                                <h2 className="text-2xl font-bold mb-6">Send us a Message</h2>

                                {formStatus.submitted && formStatus.success && (
                                    <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg flex items-start gap-3">
                                        <CheckCircle className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                                        <div>
                                            <p className="text-green-800 font-medium">Message Sent!</p>
                                            <p className="text-green-600 text-sm">{formStatus.message}</p>
                                        </div>
                                    </div>
                                )}

                                <form onSubmit={handleSubmit} className="space-y-6">
                                    {/* Name and Email Row */}
                                    <div className="grid sm:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Full Name *
                                            </label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                                className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                                                placeholder="John Doe"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Email Address *
                                            </label>
                                            <input
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                                className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                                                placeholder="john@example.com"
                                            />
                                        </div>
                                    </div>

                                    {/* Subject */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Subject *
                                        </label>
                                        <input
                                            type="text"
                                            name="subject"
                                            value={formData.subject}
                                            onChange={handleChange}
                                            required
                                            className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                                            placeholder="How can we help?"
                                        />
                                    </div>

                                    {/* Priority */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Priority Level
                                        </label>
                                        <div className="flex gap-4">
                                            {["low", "normal", "high", "urgent"].map((level) => (
                                                <label key={level} className="flex items-center gap-2">
                                                    <input
                                                        type="radio"
                                                        name="priority"
                                                        value={level}
                                                        checked={formData.priority === level}
                                                        onChange={handleChange}
                                                        className="w-4 h-4 text-indigo-600"
                                                    />
                                                    <span className="text-sm text-gray-600 capitalize">{level}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Message */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Message *
                                        </label>
                                        <textarea
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                            rows="6"
                                            className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none"
                                            placeholder="Tell us more about your question or issue..."
                                        />
                                    </div>

                                    {/* Submit Button */}
                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className="w-full bg-indigo-600 text-white py-3 rounded-lg hover:bg-indigo-700 transition-colors font-medium flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                                <span>Sending...</span>
                                            </>
                                        ) : (
                                            <>
                                                <Send className="h-4 w-4" />
                                                <span>Send Message</span>
                                            </>
                                        )}
                                    </button>

                                    <p className="text-xs text-gray-400 text-center">
                                        By submitting this form, you agree to our privacy policy and terms of service.
                                        We'll never share your information with third parties.
                                    </p>
                                </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <AuthPopup
                isOpen={showAuth}
                onClose={() => setShowAuth(false)}
            />


            {/* ================= FOOTER ================= */}
            <Footer />
        </div>
    );
};

export default Contact;